// @flow

import { observer } from "mobx-react";
import React from "react";

import UserStore from "app/stores/UserStore";
import VideoStore from "app/stores/VideoStore";
import VideoPlayerStore from "app/stores/VideoPlayerStore";
import VideoShareStore from "app/stores/VideoShareStore";

import VideoEnding from "app/components/VideoEnding/VideoEnding";

type Props = {};

@observer
export default class VideoEndingContainer extends React.Component<Props> {
    render() {
        if (!VideoPlayerStore.hasEnded) return null;

        const user = UserStore.user || {};

        const video: any = Object.assign({}, VideoStore.video, {
            created_by: user.id,
            author_name: (user.first_name + ' ' + user.last_name).trim(),
            author_username: user.username,
            author_image: user.profile_image
        });

        return (
            <VideoEnding
                video={video}
                card={!VideoStore.isOwner}
                onReplay={VideoPlayerStore.replay}
                onShare={VideoShareStore.share}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/VideoEndingContainer.js